import React from 'react'
import andew from "../../assets/images/andew.png";
import logo from "../../assets/images/commbitz_logo.svg";
import tataneu from "../../assets/images/tataneu_logo.svg";
import mic from "../../assets/images/mic.svg";
import flag from "../../assets/images/flag.png";
import spsent from "../../assets/images/spsent.svg";
import mastercard from "../../assets/images/mastercard.png";
import visa from "../../assets/images/Visa.png";
import discover from "../../assets/images/Discover.png";
import jcb from "../../assets/images/JCB.png";
import americanExpress from "../../assets/images/Amrican Express.png";
import alipay from "../../assets/images/Alipay.png";
import paypal from "../../assets/images/Paypal.png";
import unionpay from "../../assets/images/Unionpay.png";
import { Link } from 'react-router-dom'

import styles from "./style/style.module.css"

function FooterContainer() {
    //   const [popularCountries, setPopularCountries] = useState<any>("");
    return (

           <>
      <div className="row">
        <div className="col-lg-3 col-12">
          <div className={`${styles.footerInner} text-start mb-lg-2 mb-4`}>
            {/* <h6>About</h6> */}
            <div className={styles.ftLogo}>
              <span className="comlogo position-relative justify-content-start pb-3">
                <Link to='/'>
                  <span>
                    <img src={logo} alt="" width={50}/>
                  </span>
                </Link> 
                <Link to='/'>
                  <span>
                    <img src={tataneu} alt="" width={150} />
                  </span>
                </Link>
              </span>
            </div>
            <p>
              <a style={{ color: "#000", textDecoration: "none" }} href={`Tel:+447452292014`}>
                +447979717679
              </a>{" "}
              <br />
              <a style={{ color: "#000", textDecoration: "none" }} href={`mailto:hello@commbitz.com`}>
                hello@commbitz.com
              </a>
              <br />  
              <br />   
              <strong>COMMBITZ for IoT & M2M</strong>
              <br />
              <strong>COMMBITZ for Business</strong>
              <br />
              <strong>COMMBITZ for Virtual Numbers</strong>
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6 col-12 ">
          <div className={styles.footerInner}>
            <h6>Popular Countries</h6>
            <ul className={styles.footerInnerflag}>
             
                  <li
                  >
                    <img
                      src={flag}
                      width="20"
                      height="20"
                      alt=""
                    />
                    United Kingdom
                  </li>
                  <li
                  >
                    <img
                      src={flag}
                      width="20"
                      height="20"
                      alt=""
                    />
                    France
                  </li>
                  <li
                  >
                    <img
                      src={flag}
                      width="20"
                      height="20"
                      alt=""
                    />
                    India
                  </li>
                  <li
                  >
                    <img
                      src={flag}
                      width="20"
                      height="20"
                      alt=""
                    />
                    America
                  </li>
                  <li
                  >
                    <img
                      src={flag}
                      width="20"
                      height="20"
                      alt=""
                    />
                    Australia
                  </li>
                  <li
                  >
                    <img
                      src={flag}
                      width="20"
                      height="20"
                      alt=""
                    />
                    Australia
                  </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-6 col-12 ">
          <div className={styles.footerInner}>
            <h6>More Info</h6>
            <ul className={styles.partner}>
              <li>
                <a href="/">
                  Help Center
                </a>
              </li>
              <li>
                <a className="nav-Link"   href="/" target="_blank">
                  Contact
                </a>
              </li>
              <li>
                <a href="/">
                Blog
                </a>
              </li>
              <li>
                <a href="/">                  
                 Referral
                </a>
              </li>
              <li>
                <a href="/">
                 Sitemap
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-lg-3 col-md-5 col-12 mt-md-0 mt-4">
          <div className={styles.footerInner}>
            <div className={styles.Newsletter}>
              <span>Straight from our desk, to your inbox</span>
              <div className={styles.formGroup}>
                <form>
                  <input
                    type="text"
                    name="email"
                    placeholder="Your Email"
                  />
                  <input type="submit" value="Subscribe" />
                </form>
                {/* {emailSendError && (
                  <span className="error">{emailSendError}</span>
                )}
                {emailSendSuccess && <span>{emailSendSuccess}</span>} */}
              </div>
              <div className=''>
                <h6>Payment Channels</h6>
              
              <ul className={styles.payment_channels}>
                <li>
                  <img className="w-100" src={mastercard} alt="" />
                </li>
                <li>
                  <img className="w-100" src={visa} alt="" />
                </li>
                <li>
                  <img className="w-100" src={discover} alt="" />
                </li>
                <li>
                  <img className="w-100" src={jcb} alt="" />
                </li>
                <li>
                  <img className="w-100" src={americanExpress} alt="" />
                </li>
                <li>
                  <img className="w-100" src={alipay} alt="" />
                </li>
                <li>
                  <img className="w-100" src={unionpay} alt="" />
                </li>
                <li>
                  <img className="w-100" src={paypal} alt="" />
                </li>
              </ul>
              </div>
            </div>
          </div>
        </div>

        {/* {loader && <MainLoader />} */}
      </div>


    </>
       
    )
}

export default FooterContainer